var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2341_2186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.65077 18.7349C2.70421 18.7349 2.74945 18.691 2.75713 18.629L3.04764 16.3264L2.758 13.9714C2.74936 13.9095 2.70421 13.8652 2.65077 13.8652C2.59595 13.8652 2.54924 13.9105 2.54199 13.9714L2.28809 16.3264L2.54199 18.6282C2.54924 18.6901 2.59595 18.7349 2.65077 18.7349Z",
    fill: "url(#paint0_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69366 17.8589C1.74616 17.8589 1.78872 17.818 1.7964 17.757L2.02156 16.3261L1.7964 14.8685C1.78863 14.8093 1.74616 14.7666 1.69366 14.7666C1.63885 14.7666 1.59637 14.8093 1.5886 14.8694L1.40039 16.3262L1.5886 17.7567C1.59637 17.8172 1.63885 17.8589 1.69366 17.8589Z",
    fill: "url(#paint1_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79706 13.5328C3.79015 13.4579 3.73534 13.4033 3.6673 13.4033C3.59979 13.4033 3.54488 13.4579 3.53858 13.5328L3.2959 16.3261L3.53858 19.0175C3.54488 19.0919 3.59979 19.1458 3.6673 19.1458C3.73534 19.1458 3.79015 19.0919 3.79706 19.0175L4.0716 16.3261L3.79706 13.5328Z",
    fill: "url(#paint2_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6934 19.2543C4.773 19.2543 4.8374 19.1887 4.84517 19.1031L5.10461 16.3269L4.84517 13.4557C4.8374 13.3694 4.773 13.3047 4.6934 13.3047C4.61268 13.3047 4.54732 13.3695 4.5418 13.4561L4.3125 16.3269L4.5418 19.1031C4.54732 19.1888 4.61268 19.2543 4.6934 19.2543Z",
    fill: "url(#paint3_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72769 19.2997C5.82041 19.2997 5.89482 19.2254 5.90251 19.1261L5.90164 19.1267L6.14597 16.3273L5.90164 13.6633C5.89474 13.5656 5.82041 13.4902 5.72759 13.4902C5.63349 13.4902 5.5595 13.5656 5.5539 13.6641L5.33789 16.3274L5.5539 19.1261C5.55959 19.2254 5.63358 19.2997 5.72769 19.2997Z",
    fill: "url(#paint4_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19597 16.3277L6.96679 11.9962C6.9604 11.8864 6.87485 11.7988 6.76986 11.7988C6.66566 11.7988 6.58037 11.8863 6.57397 11.9962L6.37109 16.3277L6.57397 19.1264C6.58037 19.2368 6.66574 19.3231 6.76986 19.3231C6.87493 19.3231 6.9604 19.2368 6.96679 19.1264V19.1273L7.19597 16.3277Z",
    fill: "url(#paint5_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82244 19.3277C7.93808 19.3277 8.03398 19.2318 8.03937 19.1093V19.1112L8.25371 16.3284L8.03937 11.0054C8.03398 10.883 7.93808 10.7871 7.82244 10.7871C7.70414 10.7871 7.60915 10.883 7.60271 11.0054L7.41406 16.3284L7.60362 19.1103C7.60915 19.2318 7.70414 19.3277 7.82244 19.3277Z",
    fill: "url(#paint6_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88002 10.3203C8.74982 10.3203 8.64475 10.4272 8.63936 10.562L8.46387 16.3291L8.63936 19.0818C8.64482 19.2158 8.74982 19.322 8.88002 19.322C9.00987 19.322 9.11571 19.2168 9.12026 19.0814V19.0828L9.31941 16.3291L9.12026 10.562C9.11571 10.4264 9.00973 10.3203 8.88002 10.3203Z",
    fill: "url(#paint7_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94758 19.3276C10.0906 19.3276 10.2044 19.2123 10.2098 19.0637V19.0654L10.394 16.3292L10.2098 10.3683C10.2043 10.2203 10.0906 10.1045 9.94758 10.1045C9.8038 10.1045 9.68816 10.2203 9.68592 10.3683L9.52051 16.3292L9.68592 19.0654C9.68816 19.2123 9.8038 19.3276 9.94758 19.3276Z",
    fill: "url(#paint8_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0239 19.3251C11.1782 19.3251 11.3034 19.1989 11.308 19.0387V19.0411L11.4775 16.33L11.308 10.5207C11.3034 10.3607 11.1782 10.2349 11.0239 10.2349C10.8685 10.2349 10.7434 10.3605 10.7387 10.5207L10.5898 16.33L10.7397 19.0399C10.7434 19.1989 10.8685 19.3251 11.0239 19.3251Z",
    fill: "url(#paint9_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5676 16.3297L12.4142 10.7321C12.4105 10.5595 12.2753 10.4238 12.1077 10.4238C11.9395 10.4238 11.8043 10.5595 11.8007 10.7333L11.6631 16.3297L11.8007 19.023C11.8043 19.1943 11.9394 19.3301 12.1077 19.3301C12.2752 19.3301 12.4105 19.1943 12.4142 19.0206V19.023L12.5676 16.3297Z",
    fill: "url(#paint10_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2007 19.3351C13.3789 19.3351 13.5264 19.1869 13.5292 19.0046V19.0061L13.6685 16.3312L13.5292 9.67025C13.5265 9.48734 13.379 9.33936 13.2007 9.33936C13.0226 9.33936 12.8755 9.48804 12.8719 9.67123L12.748 16.3285L12.8719 19.0062C12.8755 19.1869 13.0226 19.3351 13.2007 19.3351Z",
    fill: "url(#paint11_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2886 8.71289C14.0961 8.71289 13.94 8.87249 13.9369 9.06709L13.793 16.3321L13.9377 18.9675C13.9401 19.1596 14.0963 19.3187 14.2886 19.3187C14.4781 19.3187 14.6371 19.1595 14.638 18.9643V18.9675L14.7951 16.3321L14.638 9.06709C14.6371 8.87179 14.4781 8.71289 14.2886 8.71289Z",
    fill: "url(#paint12_linear_2341_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.284 19.338C15.2918 19.3387 24.0574 19.3429 24.1137 19.3429C25.8737 19.3429 27.2998 17.8992 27.2998 16.1177C27.2998 14.3372 25.8736 12.8932 24.1137 12.8932C23.677 12.8932 23.2608 12.9825 22.8813 13.1442C22.6291 10.2373 20.221 7.95752 17.2833 7.95752C16.5652 7.95752 15.8649 8.10102 15.2465 8.34336C15.0057 8.43751 14.9413 8.53453 14.9395 8.72255V18.9564C14.9422 19.1541 15.093 19.3184 15.284 19.338Z",
    fill: "url(#paint13_linear_2341_2186)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2341_2186",
    x1: 2.66786,
    y1: 13.8652,
    x2: 2.66786,
    y2: 18.7349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2341_2186",
    x1: 1.71097,
    y1: 14.7666,
    x2: 1.71097,
    y2: 17.8589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2341_2186",
    x1: 3.68375,
    y1: 13.4033,
    x2: 3.68375,
    y2: 19.1458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2341_2186",
    x1: 4.70855,
    y1: 13.3047,
    x2: 4.70855,
    y2: 19.2543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2341_2186",
    x1: 5.74193,
    y1: 13.4902,
    x2: 5.74193,
    y2: 19.2997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2341_2186",
    x1: 6.78355,
    y1: 11.7988,
    x2: 6.78355,
    y2: 19.3231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2341_2186",
    x1: 7.83392,
    y1: 10.7871,
    x2: 7.83392,
    y2: 19.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2341_2186",
    x1: 8.89164,
    y1: 10.3203,
    x2: 8.89164,
    y2: 19.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2341_2186",
    x1: 9.95724,
    y1: 10.1045,
    x2: 9.95724,
    y2: 19.3276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2341_2186",
    x1: 11.0336,
    y1: 10.2349,
    x2: 11.0336,
    y2: 19.3251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2341_2186",
    x1: 12.1154,
    y1: 10.4238,
    x2: 12.1154,
    y2: 19.3301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2341_2186",
    x1: 13.2082,
    y1: 9.33936,
    x2: 13.2082,
    y2: 19.3351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2341_2186",
    x1: 14.294,
    y1: 8.71289,
    x2: 14.294,
    y2: 19.3187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2341_2186",
    x1: 21.1196,
    y1: 7.95752,
    x2: 21.1196,
    y2: 19.3429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2341_2186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.eb545ea7749ba6930a45ffa46c926022.svg";
export { ForwardRef as ReactComponent };